import axios from "axios";

const TIMEOUT = 30000;

// Attach token to all requests when available
axios.interceptors.request.use((config) => {
  const token = sessionStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

const handleApiError = (error) => {
  if (error.code === "ECONNABORTED" || error.message?.includes("timeout")) {
    return { success: false, message: "Request timeout. Please try again." };
  }
  if (!error.response) {
    return { success: false, message: "Network error. Please check your connection." };
  }
  // Token expiry - clear session and redirect to login
  if (error?.response?.data?.message === "Token is expired") {
    sessionStorage.clear();
    window.location.href = "/";
    return;
  }
  return error?.response?.data ?? { success: false, message: "An error occurred." };
};

export const apiPost = async (url, params, headers = {}) => {
  try {
    const response = await axios.post(url, params, {
      headers: { "Content-Type": "application/json", ...headers },
      timeout: TIMEOUT,
    });
    return response?.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const apiGet = async (url, headers = {}, params = {}) => {
  try {
    const response = await axios.get(url, {
      headers: { "Content-Type": "application/json", ...headers },
      params: Object.keys(params).length ? params : undefined,
      timeout: TIMEOUT,
    });
    return response?.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const apiPut = async (url, params, headers = {}) => {
  try {
    const response = await axios.put(url, params, {
      headers: { "Content-Type": "application/json", ...headers },
      timeout: TIMEOUT,
    });
    return response?.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const apiPatch = async (url, params, headers = {}) => {
  try {
    const response = await axios.patch(url, params, {
      headers: { "Content-Type": "application/json", ...headers },
      timeout: TIMEOUT,
    });
    return response?.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const apiDelete = async (url, headers = {}) => {
  try {
    const response = await axios.delete(url, {
      headers: { "Content-Type": "application/json", ...headers },
      timeout: TIMEOUT,
    });
    return response?.data;
  } catch (error) {
    return handleApiError(error);
  }
};

/** Post FormData (multipart/form-data). Do not set Content-Type - axios sets it with boundary. */
export const apiPostForm = async (url, formData, headers = {}) => {
  try {
    const response = await axios.post(url, formData, {
      headers: { ...headers },
      timeout: 60000,
    });
    return response?.data;
  } catch (error) {
    return handleApiError(error);
  }
};

/** Put FormData (multipart/form-data). Do not set Content-Type - axios sets it with boundary. */
export const apiPutForm = async (url, formData, headers = {}) => {
  try {
    const response = await axios.put(url, formData, {
      headers: { ...headers },
      timeout: 60000,
    });
    return response?.data;
  } catch (error) {
    return handleApiError(error);
  }
};

/** Returns headers with Authorization token for authenticated requests */
export const getAuthHeaders = () => {
  const token = sessionStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};
